import React from 'react';
import { Edit } from 'react-admin';
import FundInvestorSummary from './FundInvestorSummary';
import { withStyles } from '@material-ui/core/styles';
import { FormSpy } from 'react-final-form';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const styles = () => ({
  fullWidth: {
    width: '100%'
  },
  form: {
    '& > div': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important'
    }
  }
});

const FundInvestorForm = props => {
  const {
    handleSubmit,
    setFundInvestorFormProps,
    operation,
    investorId,
    fundId,
    showDialog,
    handleDialogToggle,
    showNotification,
    fetchStart,
    fetchEnd,
    crudGetList,
    loaded,
    currentSort,
    setSort,
    classes,
    ...operationProps
  } = props;
  if (operation === 'Create') {
    return (
      <CustomSimpleForm
        initialValues={{ investors: [], funds: [], investorId, fundId }}
        toolbar={null}
        // We override the redux-form name to avoid collision with the react-admin main form
        resource="fundinvestors"
        // We override the redux-form onSubmit prop to handle the submission ourselves
        save={handleSubmit}
        className={classes.form}
        variant="standard"
        margin="normal"
      >
        <FormSpy>
          {props => {
            setFundInvestorFormProps(props);
            return (
              <FundInvestorSummary
                {...props}
                creation={true}
                investorId={investorId}
                fundId={fundId}
              />
            );
          }}
        </FormSpy>
      </CustomSimpleForm>
    );
  } else {
    return (
      <Edit {...operationProps} record={{}} className={classes.fullWidth}>
        <CustomSimpleForm
          initialValues={{ investorId, fundId }}
          toolbar={null}
          // We override the redux-form name to avoid collision with the react-admin main form
          resource="fundinvestors"
          // We override the redux-form onSubmit prop to handle the submission ourselves
          save={handleSubmit}
          variant="standard"
          margin="normal"
        >
          <FormSpy>
            {props => {
              setFundInvestorFormProps(props);
              return (
                <FundInvestorSummary
                  {...props}
                  investorId={investorId}
                  fundId={fundId}
                />
              );
            }}
          </FormSpy>
        </CustomSimpleForm>
      </Edit>
    );
  }
};

export default withStyles(styles)(FundInvestorForm);
